import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import {Arguments} from "../common/Arguments";
import {sideMenuContext} from "../../../router/IndexRouter";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import {ExportToExcel} from "../common/ExportDataToExcelComponent";
import {DateRangePicker} from "../common/SelectDateRange";
import {camelObj} from "../common/ConversionMethod";


export default function PartyActivitiesAdmin(props) {
    const {dataSource, setDataSource, setCurrentItem, copyDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/home/api!organizationPartyActivity.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const detailClick = (item) => {
        // 将数据改成驼峰形式保存在 currentItem 中，方便详情页审核提交用
        setCurrentItem(camelObj(item));
        window.open(Arguments.reactUrl + "/base/party-activities-admin/detail", "_self");
    }

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 90,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '社会组织',
            dataIndex: 'organization_name',
            width: 150
        },
        {
            title: '活动主题',
            dataIndex: 'activity_name',
            width: 220
        },
        {
            title: "主持人",
            dataIndex: 'activity_compere',
            width: 120
        },
        {
            title: "活动时间",
            dataIndex: 'activity_date',
            width: 120
        },
        {
            title: "活动形式",
            responsive: ['lg'],
            dataIndex: 'activity_form',
            width: 200
        },
        {
            title: "参加人数",
            responsive: ['lg'],
            dataIndex: 'activity_scope',
            width: 100
        },
        {
            title: "活动地址",
            dataIndex: 'activity_address',
            width: 240
        },
        {
            title: "审核状态",
            dataIndex: 'check_status',
            width: 100
        },
        {
            title: "操作",
            width: 120,
            render: (item) => (
                <Button type="link" onClick={() => detailClick(item)}>查看详情</Button>
            )
        }
    ];

    const newData = dataSource.map(
        (
            {
                organization_name,
                activity_name,
                activity_compere,
                activity_date,
                activity_address,
                activity_form,
                activity_scope,
                activity_memo,
                activity_apply_money,
                activity_approval_money,
                check_status
            }
        ) => (
            {
                "社会组织": organization_name,
                "活动主题": activity_name,
                "主持人": activity_compere,
                "活动时间": activity_date,
                "活动地点": activity_address,
                "活动类别": activity_form,
                "参加人数": activity_scope,
                "活动备注": activity_memo,
                "申请经费": activity_apply_money,
                "审批经费": activity_approval_money,
                "审核状态": check_status
            }
        )
    )

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <ExportToExcel tableData={newData}/>
            <DateRangePicker dataSource={dataSource} setDataSource={setDataSource} copyDataSource={copyDataSource}/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}